// src/lib/pocketbase.js
import PocketBase from 'pocketbase';
import { POCKETBASE_URL } from '../config';

const pb = new PocketBase(POCKETBASE_URL);
// Avoid ClientResponseError autocancel when many realtime creates/updates race
pb.autoCancellation(false);


function syncAuthCookie() {
  document.cookie = pb.authStore.exportToCookie({ httpOnly: false });
}

function resetRealtime() {
  try {
    if (pb.realtime && typeof pb.realtime.disconnect === 'function') {
      pb.realtime.disconnect();
    }
  } catch {
    // ignore
  }
}

let previousToken = null;

pb.authStore.loadFromCookie(document.cookie);
previousToken = pb.authStore.token;
syncAuthCookie();

pb.authStore.onChange(() => {
  const token = pb.authStore.token;

  if (token !== previousToken) {
    resetRealtime();
    previousToken = token;

    if (typeof window !== 'undefined') {
      window.dispatchEvent(new CustomEvent('pb-auth-changed'));
    }
  }

  syncAuthCookie();
});

// When Maguen PB restarts, force clients to rebind subscriptions
if (typeof window !== 'undefined') {
  window.addEventListener('online', () => {
    window.dispatchEvent(new CustomEvent('pb-auth-changed'));
  });
}

export default pb;
